package com.xtream.composeapp

import kotlin.OptIn
import kotlin.String
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@JsExport
@OptIn(ExperimentalJsExport::class)
public actual object SharedBuildKonfig {
  public actual val FLAVOR: String = "intvplus"

  public actual val QR_CODE_URL: String = "https://intvplayer.tv/upload-playlist?mac="

  public actual val VERSION_NAME: String = "4.29"

  public actual val SERVER_CONFIG: String = "https://intvpro.intvplayer.com/appb64"

  public actual val PLAYER_SERVER: String = "https://intvplayer.tv"

  public actual val PLAYER_SERVER_API_KEY: String = "sk_live_rPRqa7hKgKT2ecSMN6Xz3nxfknv9iCpg"

  public actual val AD_SERVER: String = "https://intvpro.intvplayer.com"

  public actual val SERVER_API: String = "/player_api.php"

  public actual val APP_NAME: String = "InTV+"

  public actual val SUPPORT_TELEGRAM: String = "t.me/InTv_Plus"

  public actual val SUPPORT_EMAIL: String = "support@intvplus.net"

  public actual val DOMAIN_ADDRESS: String = "intvplus.net"

  public actual val SUPPORT_WHATSAPP: String = "+964 782 444 3968"

  public actual val SUPPORT_WHATSAPP2: String = "+44 7575 890413"
}
